import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { User } from "../../_models/user";

@Component({
  selector: 'app-gati-create',
  templateUrl: './gati-create.component.html',
  styleUrls: ['./gati-create.component.scss'],
})
export class GatiCreateComponent implements OnInit {
  carrierName: string;
  carrierNameError: string;
  customerCode: string;
  customerCodeError: string;

  constructor(private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {


  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  customerCodeBlur() {
    this.customerCodeError = "";
    if (!this.customerCode) {
      this.customerCodeError = 'Please enter customer code';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.customerCodeError = "";

    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.customerCode) {
      this.customerCodeError = 'Please enter customer code';
    }
    if (this.carrierNameError != "" || this.customerCodeError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyAndSaveCarrierCredentials', {

      "customerCode": this.customerCode,
      "accountOwnerId": this.user.accountOwnerId,
      "carrierCode": "GT",
      "connectionName": this.carrierName,
      "organizationId": 1

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Gati', 'Create Successfully');
          this.router.navigate(['/admin/customerCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}
